export default __webpack_public_path__ + "static/media/Instagram.1f55bf75.PNG";